import Sidebar from 'components/molecules/Sidebar/Sidebar';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { List, ListItem, ListItemText } from '@mui/material';

interface ISidebarNavigation {
  routes: {
    title: string;
    path: string;
  }[];
}

const SidebarNavigation: FC<ISidebarNavigation> = ({ routes }) => {
  return (
    <Sidebar>
      <List>
        {routes.map(route => (
          <Link key={route.title} to={route.path}>
            <ListItem button>
              <ListItemText primary={route.title} />
            </ListItem>
          </Link>
        ))}
      </List>
    </Sidebar>
  );
};

export default SidebarNavigation;
